// Angular
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
// 3rdParty 
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
// Hostware 
import { BottomBarService } from '@app/services/bottom-bar.service';
import { ImageCaptureService } from '@app/services/image-capture-service';
import { SpinnerService } from '@app/services/spinner.service';
import { TranslateService } from '@ngx-translate/core';
import { GenericMessageDialogComponent } from '@app/dialogs/generic-message-dialog/generic-message-dialog.component';
import { GenericMessage } from '@app/interfaces/generic-message';
import HwUtils from '@app/helpers/HwUtils';
import SessionStorage from '@app/helpers/SessionStorage';
import { LogService } from '@app/services/log.service';
import LocalStorage from '@app/helpers/LocalStorage';
import { HwLogDto } from '@app/dto/HwLogDto';


@AutoUnsubscribe()
@Component({
  selector: 'image-capture2',
  templateUrl: './image-capture2.component.html',
  styleUrls: ['./image-capture2.component.scss'],
})
export class ImageCapture2Component implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('captureCanvas', { static: true }) captureCanvas: ElementRef;
  @ViewChild('video', { static: true }) videoRef!: ElementRef<HTMLVideoElement>;
  @Input() instructionLine: string

  spinnerVisible: boolean

  landscape: boolean;
  myVideo: any
  currentStream = null;
  facingMode: FacingModes = FacingModes.Environment
  captureContext: CanvasRenderingContext2D;
  // instructionLine: string;
  expoSound = new Audio()
  isDestroyed: boolean = false;
  isCameraStarting: boolean = false;
  isSelfieMode: boolean = false; // Added property
  isDesktop = !SessionStorage.IsMobile
  processing : boolean = false;

  constructor(
    private breakPointObserver: BreakpointObserver,
    private imageCaptureService: ImageCaptureService,
    private bottomBarService: BottomBarService,
    private spinnerService: SpinnerService,
    private dialog : MatDialog,
    private translate: TranslateService,
    private hwLogService : LogService,
    private cr : ChangeDetectorRef

  ) { }

  //#region =============== Angular Lifecyle events ============================================================================

  ngOnInit(): void {
    this.imageCaptureService.setInstructionText.subscribe(messageText => {
      // HwUtils.log("InstructionLine= " + messageText)
      // this.instructionLine = messageText
      // this.cr.detectChanges();
    })
 
    this.imageCaptureService.processFinished.subscribe(()=> {
      this.processing = false;
    })
    this.expoSound.src = '../../../assets/sounds/expose.mp3'
    HwUtils.log( "IsDesktop" + this.isDesktop)
    HwUtils.log("ImageCapture2Component ngOnInit")
     let messageData: GenericMessage = { messageText: this.translate.instant('photo.rotate_pls'), messageType: 'ERROR' , showIcon: true}
    this.myVideo = this.videoRef.nativeElement
    this.facingMode = FacingModes.Environment
    // this.instructionLine = "fack"//this.translate.instant("photo.read_faceimage_side");
    this.bottomBarService.setBottomBarVisibility(false);
    this.breakPointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait

    ]).subscribe((state: BreakpointState) => {
      if (state.breakpoints[Breakpoints.HandsetLandscape]) {
        this.landscape = true;
      }
      if (state.breakpoints[Breakpoints.HandsetPortrait]) {
        this.landscape = false;
      }
    })

    this.imageCaptureService.startCapture.subscribe(captureMode => {
      HwUtils.log("ImageCapture2Component startCapture " + captureMode)
      if (captureMode == 'DOCUMENT') {
        this.facingMode = FacingModes.Environment
        this.isSelfieMode = false; // Update flag
      } else {
        this.facingMode = FacingModes.User
        this.isSelfieMode = true; // Update flag
      }
      console.log("startCapture =" + this.facingMode)
        this.startCamera(this.facingMode)
    })

    this.imageCaptureService.setFacingMode.subscribe(facingMode => {
      this.selectFacingMode(facingMode)
    })
    this.imageCaptureService.releaseCamera.subscribe(() => {
      this.stopCamera();

    })
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      this.startCamera(this.facingMode)
    } else {
      
      HwUtils.log("ImageCapture2Component no camera");
    }
  }
  ngAfterViewInit(): void {
    this.captureContext = this.captureCanvas.nativeElement.getContext("2d")
  }
  ngOnDestroy(): void {
    this.isDestroyed = true;
    this.stopCamera()
  }

  //#endregion =================================================================================================================

  //#region =============== List event hadlers   ===============================================================================
  //#endregion =================================================================================================================

  //#region =============== Form events ========================================================================================

  capture(event: Event) {
     this.processing = true;
    this.expoSound.play();
    const videoElement = this.videoRef.nativeElement;
    HwUtils.log("ImageCapture2Component capture")
    const canvas = document.createElement('canvas');
    canvas.width = videoElement.videoWidth;
    canvas.height = videoElement.videoHeight;
    
    // this.hwLogService.WriteLogItem({
    //   ClassName: "Capture",
    //   HotelId: parseInt(SessionStorage.ReservationInfo.Hotelid),
    //   LogLevel : "INFO",
    //   Message: "canvas size: " + canvas.width + "x" + canvas.height,
    //   MethodName : "Capture",
    //   SData:'',
    //   Subscriber: SessionStorage.ReservationInfo.Subscriber,
    //   Subsystem: "EXI",
    //   Sysdat: '',
    //   UserName : SessionStorage.SelectedGuestData.GuestStayUuId

    // }).subscribe( result=> {
      
    // })
    canvas.getContext('2d').drawImage(videoElement, 0, 0, canvas.width, canvas.height);
    let dataURL: string = canvas.toDataURL('image/jpeg', 1);
    try {
      // const fullQuality = dataURL.replace(/^data:image\/jpeg;base64,/, '');
      const fullQuality = dataURL.split(',')[1];
      this.imageCaptureService.imageApproved.emit(fullQuality)
     
      event.stopPropagation();
    } catch (err) {
      console.error(err)
    }
  }

  //#endregion =================================================================================================================

  //#region =============== Dialog events ======================================================================================

  //#endregion =================================================================================================================

  //#region =============== Validation    ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Functions  =========================================================================================

  async startCamera(facingMode: FacingModes) {
    if (this.isCameraStarting) {
      console.log("Camera start already in progress, skipping.");
      return;
    }
    HwUtils.log("ImageCapture2Component startCamera")
    this.isCameraStarting = true;
    this.stopCamera();

    const constraints = {
      video: {
        facingMode: facingMode
      }
    };

    try {
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      if (this.isDestroyed) {
        console.warn("Component destroyed while waiting for camera stream. Release stream immediately.");
        stream.getTracks().forEach(track => track.stop());
        return;
      }
      this.currentStream = stream;
      if (this.myVideo) {
        this.myVideo.srcObject = stream;
        await new Promise((resolve, reject) => {
          this.myVideo.onloadedmetadata = resolve;
          this.myVideo.onerror = reject;
        });
      }
    } catch (error) {
      if (!this.isDestroyed) {
        let messageData: GenericMessage = { messageText: this.translate.instant('photo.no_access_to_camera'), messageType: 'ERROR' , showIcon: true}
        const dialogRef = this.dialog.open(GenericMessageDialogComponent, {
        disableClose: true,
        hasBackdrop: true,
        width: "auto",
        data: messageData
      })
        console.error(facingMode);
        console.error("Error accessing camera:", error);
      }
    } finally {
      this.isCameraStarting = false;
    }
  }
  stopCamera() {
    console.log("Stopping camera...");
    this.facingMode = FacingModes.Environment;
    if (this.currentStream) {
      this.currentStream.getTracks().forEach(track => {
        console.log(`Stopping track: ${track.kind}, id: ${track.id}`);
        track.stop();
      });
      this.currentStream = null;
      if (this.myVideo) {
        this.myVideo.pause();
        this.myVideo.srcObject = null;
        this.myVideo.load(); // Helps in some browsers to fully detach
      }
    }

    console.log("Camera stopped.");
  }

  async selectFacingMode(facingMode: FacingModes) {
    const videoTrack = this.currentStream.getVideoTracks()[0];

    // 1. Check the camera's capabilities
    const capabilities = videoTrack.getCapabilities();
    const currentConstraints = videoTrack.getConstraints();
    if ('focusMode' in capabilities) {
      const finalConstraints = {
        ...currentConstraints,// Set the desired facing mode
        facingMode: facingMode
      };

      try {
        // 2. Apply the constraints to the video track
        await videoTrack.applyConstraints({
          finalConstraints // Use 'advanced' for non-required settings
        });
        let anew = videoTrack.getSettings();
        console.log("Current active facingMode:", anew.facingMode);
        console.log(`FacingMode ${anew.facingMode} enabled`);
      } catch (err) {
        console.error('Failed to apply facingMode constraints:', err);
      }
    } else {
      console.log('The camera does not support facingMode control.');
    }
  }
  // style functions
  landscapeStyle(landscape: boolean) {
    let styles = {};
    if (!landscape) {
      styles["visibility"] = "hidden";
    } else {
      styles["visibility"] = "visible";
    }
    return styles;
  }

  
  //#endregion =================================================================================================================

}


/*
  async enableContinuousAutofocus() {
    const videoTrack = this.currentStream.getVideoTracks()[0];

    // 1. Check the camera's capabilities
    const capabilities = videoTrack.getCapabilities();
    const currentConstraints = videoTrack.getConstraints();
    if ('focusMode' in capabilities) {
      const finalConstraints = {
        ...currentConstraints,// Set the desired focus mode
        focusMode: 'continuous'
      };

      try {
        // 2. Apply the constraints to the video track
        await videoTrack.applyConstraints({
          finalConstraints // Use 'advanced' for non-required settings
        });
        let anew = videoTrack.getSettings();
        console.log("Current active focusMode:", anew.focusMode);
        console.log('Continuous autofocus enabled.');
      } catch (err) {
        console.error('Failed to apply focus constraints:', err);
      }
    } else {
      console.log('The camera does not support focusMode control.');
    }
  }

*/
export enum FacingModes {
  'Environment' = 'environment',
  'User' = 'user'
}

